import permissions from '@/features/Share/config/permissions';
import TaskManager from '@TaskManager/views/TaskManager.vue';

export default [
  {
    path: '/:id/admin/task-manager',
    name: 'taskManager',
    component: TaskManager,
    meta: {
      requiresAuth: true,
      facilityScope: true,
      layout: 'admin-layout',
      title: 'TaskManager',
      permissions: [permissions.AdminTaskManager.View],
    },
  },
];
